export interface ICreateAccountDto {
    organizationId?: string;
    name: string;
    code: string;
    businessName: string;
    country: string;
    address?: string;
    vatNumber: string;
    email: string;
    externalId?: string;
    locations?: string[];
    tags?: string[];
    phoneNumber?: string;
}
